const InitHeroBannerVideo = (): void => {
    const videoBanners = document.querySelectorAll<HTMLElement>('.hero-banner-video');

    if (!videoBanners.length) {
        return;
    }

    videoBanners.forEach(banner => {
        const video = banner.querySelector<HTMLVideoElement>('video');
        const playPauseBtn = banner.querySelector<HTMLButtonElement>('.hero-banner-video-play-btn');

        if (!video || !playPauseBtn) {
            return;
        }

        const playIcon = playPauseBtn.querySelector<HTMLElement>('.play-button-icon');
        const pauseIcon = playPauseBtn.querySelector<HTMLElement>('.pause-button-icon');

        if (!playIcon || !pauseIcon) {
            return;
        }

        // Read the actual video state
        const initiallyPaused = video.paused;
        let isPlaying = !initiallyPaused;

        const updateButtonIcon = (showPlay: boolean): void => {
            if (showPlay) {
                playIcon.style.display = 'block';
                pauseIcon.style.display = 'none';
                playPauseBtn.setAttribute('aria-label', 'Play video');
                playPauseBtn.setAttribute('aria-pressed', 'false');
            } else {
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
                playPauseBtn.setAttribute('aria-label', 'Pause video');
                playPauseBtn.setAttribute('aria-pressed', 'true');
            }
        };

        updateButtonIcon(initiallyPaused);

        playPauseBtn.addEventListener('click', () => {
            if (isPlaying) {
                video.pause();
                updateButtonIcon(true);
            } else {
                video.play();
                updateButtonIcon(false);
            }
            isPlaying = !isPlaying;
        });

        video.addEventListener('play', () => {
            updateButtonIcon(false);
            isPlaying = true;
        });

        video.addEventListener('pause', () => {
            updateButtonIcon(true);
            isPlaying = false;
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', InitHeroBannerVideo);
} else {
    InitHeroBannerVideo();
}

export default InitHeroBannerVideo;
